module.exports = "domestic-1.22.2-a6049718e75b05c5c03ee3143f430561ff873f0f";